<template>
  <!-- THIS PAGE IS A MERELY EXAMPLE, USE REGISTERPAGETEMPLATE -->
  <RegisterPageTemplate
    :titles="pageTitles"
    :data="fullList"
    :columns="columnsCards"
    sort-columns-by-key="measurement"
    order-by-desc
    side-action-component="SoilForm"
    :get-data-func="getData"
  />
</template>

<script>
import { soilUseCase } from "@/api/modules/soil/useCases";
import RegisterPageTemplate from "@/pages/temps/pages/RegisterPageTemplate";
export default {
  components: {
    RegisterPageTemplate,
  },
  data() {
    return {
      fullList: [],
      list: [],
      pageTitles: ['Cadastrar', 'Solos'],
      columnsCards: [
        {
          title: 'Densidade Aparente',
          key: 'DENSITY',
          icon: '',
          measurement: 'g/cm³',
          format: 'float'
        },
        {
          title: 'Capacidade de Campo',
          key: 'FIELD_CAPACITY',
          transformData: (val) => val * 100,
          icon: '',
          measurement: '%',
          format: 'float'
        },
        {
          title: 'Transmissividade do Solo',
          key: 'TRANSMISSIVITY',
          icon: '',
          transformData: (val) => val * 100,
          measurement: '%',
          format: 'float'
        },
        {
          title: 'Ponto de Murcha Permanente',
          key: 'WILT_POINT',
          transformData: (val) => val * 100,
          icon: '',
          measurement: '%',
          format: 'float'
        },
        {
          title: 'Data de Atualização',
          key: 'UPDATE',
          icon: '',
          measurement: '',
          format: 'date'
        },
        {
          title: 'Nome do editor',
          key: 'EDITOR_NAME',
          icon: '',
          measurement: '',
        },
      ]
    };
  },
  async created() { 
    await this.getData();
  },
  computed: {
    headTabTitle() {
      return this.pageTitles.map((title, i) => {
        if(!i) {
          return `${title.charAt(0)}.`;
        }

        return title.charAt(0).toUpperCase() + title.slice(1);
      }).join(" ")
    }
  },
  methods: {
    async getData() {
      return soilUseCase().show.execute();
    },
  },
};
</script>